import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export function SellerRoute({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth();
  const [checking, setChecking] = useState(true);
  const [isActiveSeller, setIsActiveSeller] = useState(false);

  useEffect(() => {
    if (!session?.user?.id) { setChecking(false); return; }
    (async () => {
      const { data } = await supabase
        .from('seller_profiles')
        .select('is_active')
        .eq('user_id', session.user.id)
        .maybeSingle();
      setIsActiveSeller(!!data?.is_active);
      setChecking(false);
    })();
  }, [session?.user?.id]);

  if (loading || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }
  if (!session) return <Navigate to="/login" replace />;
  if (!isActiveSeller) return <Navigate to="/seller/apply" replace />;
  return <>{children}</>;
}
